// extracted by mini-css-extract-plugin
export default {"mortgageProcess":"MortgageProcess_mortgageProcess__wlkKj"};